// extracted by mini-css-extract-plugin
module.exports = {"root":"SmallHeader_root__3KtcJ","dark":"SmallHeader_dark__1N173"};